import { Customer } from "~/models/Customer"
import { Product } from "~/models/Product"
import { sum } from "~/utils/ExtendFunctions"
import { PageKey } from "~/models/Page"
import { SelectData } from "~/models/SelectData"
import { PlanType } from "~/models/Plan"
import { DEFAULT_PLAN } from "~/data/constants/DiscountRate"
import { Summary, SummaryKey } from "~/models/Summary"
import { Setting } from "~/utils/Setting"

export const Calculation = {

  inTax: (price): number => {
    return price * ((100 + Setting.data.taxRate) / 100)
  },
  tax: (price): number => {
    return price * ((Setting.data.taxRate) / 100)
  },
  price: (product: Product, planType: `${PlanType}`): number => {
    return product?.price?.amounts?.[planType] || product?.price?.standardCost || 0
  },
  summaries: (productData: any, customerData: Customer): Summary[] => {
    const storeSummaries: Summary[] = []

    const allProducts = Object.fromEntries(Object.keys(productData.result).flatMap((type) => {
      return productData.result[type].map((item) => {
        return item
      })
    }).map(item => [item.id, item])) as { ID: Product }
    customerData.stores.forEach((store, index) => {

      const selectData = store.selectData || {} as SelectData
      const planType = selectData.basicPack?.planType || DEFAULT_PLAN

      storeSummaries[index] = {
        total: {
          initPrice: 0,
          initCost: 0,
          price: 0
        },
        subtotals: [
          {
            key: SummaryKey.Total,
            title: "店舗支払",
            items: [],
            sum: {
              initPrice: 0,
              initCost: 0,
              price: 0
            }
          },
          {
            key: SummaryKey.Service,
            title: "サービス",
            items: [],
            sum: {
              initPrice: 0,
              initCost: 0,
              price: 0
            }
          },
          {
            key: SummaryKey.BasicPack,
            title: "基本パック",
            items: ([...(selectData[PageKey.BasicPack]?.ids || []), ...(selectData[PageKey.AddPack]?.ids || [])]).filter(id => {
              return allProducts[id] && (allProducts[id].category === "basicPack" || allProducts[id].category === "addFnc")
            }).map(id => ({
              ...allProducts[id],
              contract: selectData?.basicPack.contracts[id] || 1,
              charge: Calculation.price(allProducts[id], planType)
            })),
            sum: {
              initPrice: 0,
              initCost: 0,
              price: 0//sum((store.selectData.basicPack.ids || []).map(id => allProducts[id].price)),
            }
          },
          {
            key: SummaryKey.AddPack,
            title: "ロールバック",
            items: (selectData[PageKey.AddPack]?.ids || []).filter(id => allProducts[id] && allProducts[id].category === "rolePack").map(id => ({
              ...allProducts[id],
              contract: selectData?.addPack.contracts[id] || 1,
              charge: Calculation.price(allProducts[id], planType)
            })),
            sum: {
              initPrice: 0,
              initCost: 0,
              price: 0 //sum((store.selectData.addPack.ids || []).map(id => allProducts[id].price)),
            }
          },
          {
            key: SummaryKey.Option,
            title: "オプション",
            items: (selectData[PageKey.Option]?.ids || []).filter(id => allProducts[id]).map(id => ({
              ...allProducts[id],
              contract: selectData?.option.contracts[id] || 1,
              charge: Calculation.price(allProducts[id], planType)
            })),
            sum: {
              initPrice: 0,
              initCost: 0,
              price: 0 //sum((store.selectData.addPack.ids || []).map(id => allProducts[id].price)),
            }
          },
          {
            key: SummaryKey.Database,
            title: "データベース",
            items: (selectData[PageKey.Database]?.ids || []).filter(id => allProducts[id]).map(id => ({
              ...allProducts[id],
              contract: selectData?.database.contracts[id] || 1,
              charge: Calculation.price(allProducts[id], planType)
            })),
            sum: {
              initPrice: 0,
              initCost: 0,
              price: 0 //sum((store.selectData.database.ids || []).map(id => allProducts[id].price))
            }
          },
          {
            key: SummaryKey.MaService,
            title: "メンテナンスサービス",
            items: (selectData[PageKey.MaService]?.ids || []).filter(id => {
              return allProducts[id] && (allProducts[id].category === "othopt" || allProducts[id].category === "sptMonthly");
            }).map(id => ({
              ...allProducts[id],
              contract: selectData?.maService.contracts[id] || 1,
              charge: Calculation.price(allProducts[id], planType)
            })),
            sum: {
              initPrice: 0,
              initCost: 0,
              price: 0
            }
          },
          {
            key: SummaryKey.InstSup,
            title: "導入支援",
            items: (selectData[PageKey.MaService]?.ids || []).filter(id => allProducts[id] && allProducts[id].category === "sptFnc").map(id => ({
              ...allProducts[id],
              contract: selectData?.maService.contracts[id] || 1,
              charge: Calculation.price(allProducts[id], planType)
            })),
            sum: {
              initPrice: 0,
              initCost: 0,
              price: 0
            }
          }
        ]
      }
      const summaries = storeSummaries[index]
      summaries.subtotals.forEach(item => {
        const totalPrice = sum((item.items || []).map(item => Calculation.price(item, planType) * item.contract))
        item.sum.initPrice = totalPrice + item.sum.initCost
        item.sum.price = totalPrice
      })
      summaries.subtotals.forEach(item => {
        summaries.total.initPrice += item.sum.initPrice
        summaries.total.initCost += item.sum.initCost
        summaries.total.price += item.sum.price
      })

    })
    return storeSummaries
  }
}
